import { Component, OnInit, Input } from '@angular/core';
import { TimelineHelper } from '../../../core/helpers/timeline-helper';
import { TimelineEnum } from '../../../core/enums/timeline-enum';
import { AuthenticationService } from '../../../core/authentication/authentication.service';
import { StatusEnum } from '../../../core/enums/status-enum';

@Component({
  selector: 'app-mile-stone',
  templateUrl: './mile-stone.component.html'
})
export class MileStoneComponent implements OnInit {
  requestListed;
  currentUser: any;
  reviewDeal: any;
  paymentInProgress: any;
  paymentCompleted: any;
  shipmentCompleted: any;
  requestStatusEnum = StatusEnum;
  timelineEnum = TimelineEnum;

  constructor(authenticationService: AuthenticationService) {
    authenticationService.getUserClaims().subscribe(currentUser => {
      this.currentUser = currentUser;
      this.requestListed = TimelineHelper.getTimelineTranslationKey(TimelineEnum.RequestListed, this.currentUser.role)
      this.reviewDeal = TimelineHelper.getTimelineTranslationKey(TimelineEnum.ReviewDeal, this.currentUser.role)
      this.paymentInProgress = TimelineHelper.getTimelineTranslationKey(TimelineEnum.PaymentInProgress, this.currentUser.role)
      this.paymentCompleted = TimelineHelper.getTimelineTranslationKey(TimelineEnum.PaymentCompleted, this.currentUser.role)
      this.shipmentCompleted = TimelineHelper.getTimelineTranslationKey(TimelineEnum.ShipmentCompleted, this.currentUser.role)
    });
  }

  @Input('timeline') timeline: TimelineEnum;
  @Input('listDate') listDate;
  @Input('requestStatus') requestStatus: StatusEnum;

  ngOnInit() {
  }

  getStateOfRequestListed() {
    if (this.timeline === TimelineEnum.RequestListed) {
      if (this.requestStatus !== StatusEnum.Cancelled && this.requestStatus !== StatusEnum.Expired) {
        return 'request-listed-ms';
      } else {
        if (this.requestStatus === StatusEnum.Cancelled) {
            return 'request-cancelled-ms';
        } else if (this.requestStatus === StatusEnum.Expired) {
          return 'request-expired-ms';
        }
      }
    } else {
      return 'request-listed-ms';
    }
  }

  getStateOfReviewDeal() {
    if (this.timeline < TimelineEnum.ReviewDeal) {
      return 'review-deal-ms';
    } else {
      if ((this.requestStatus === StatusEnum.ShipperExitedDealBeforePayment
        || this.requestStatus === StatusEnum.CarrierExitedDealBeforePayment) && this.timeline == TimelineEnum.ReviewDeal) {
          return 'review-deal-ms-exited';
      } else if (this.requestStatus === StatusEnum.DealExpired && this.timeline === TimelineEnum.ReviewDeal) {
        return 'review-deal-ms-expired';
      } else {
        return 'review-deal-ms-active';
      }
    }
  }

  getStateOfPaymentCompleted() {
    if (this.timeline < TimelineEnum.PaymentCompleted) {
      return 'payment-completed-ms';
    } else {
      if (this.requestStatus === StatusEnum.ShipperExitedDealAfterPayment
        || this.requestStatus === StatusEnum.CarrierExitedDealAfterPayment) {
          return 'payment-completed-ms-exited';
      } else {
        return 'payment-completed-ms-active';
      }
    }
  }

  getStateOfPaymentInProgress() {
    if (this.timeline < TimelineEnum.PaymentInProgress) {
      return 'payment-in-progress-ms';
    } else {
      if (this.requestStatus === StatusEnum.ShipperExitedDealInPaymentPending
        || this.requestStatus === StatusEnum.CarrierExitedDealInPaymentPending || this.requestStatus === StatusEnum.ShipperExitedDealBeforePayment) {
          return 'payment-in-progress-ms-exited';
      } else if (this.requestStatus === StatusEnum.DealExpired && this.timeline === TimelineEnum.PaymentInProgress) {
        return 'payment-in-progress-ms-expired';
      } else {
        return 'payment-in-progress-ms-active';
      }
    }
  }

  getStateOfShipmentCompleted() {
    if (this.timeline === TimelineEnum.ShipmentCompleted) {
      if ([StatusEnum.ShipperExitedDealAfterClosed, StatusEnum.CarrierExitedDealAfterClosed, StatusEnum.SupplierPenalisedDeal]
        .find(x => x === this.requestStatus) != null) {
          return 'shipment-completed-ms-exited';
        } else {
          return 'shipment-completed-ms-active';
        }
    } else {
      return 'shipment-completed-ms';
    }
  }
}
